"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringEscapeNewlines = void 0;
// Escape newlines in a string, so they can be displayed as \n or \r in the UI
const stringEscapeNewlines = (str) => str.replace(/\n/g, '\\n').replace(/\r/g, '\\r');
exports.stringEscapeNewlines = stringEscapeNewlines;
